export default {
    endTransaction: (name) => {
        if (window.atatus) {
            window.atatus.endTransaction(name);
        }
    },
    failTransaction: (name) => {
        if (window.atatus) {
            window.atatus.failTransaction(name);
        }
    },
    notify: (error, customData, tags) => {
        if (window.atatus) {
            window.atatus.notify(error, customData, tags);
        }
    },
    recordTransaction: (name, time, success = true) => {
        if (window.atatus) {
            window.atatus.recordTransaction(name, Math.round(time), success);
        }
    },
    startTransaction: (name) => {
        if (window.atatus) {
            window.atatus.beginTransaction(name);
        }
    },
};
